export const scanAudioAlert = (message, voice) => {
  let msg = new SpeechSynthesisUtterance();
  msg.voice = voice;
  msg.volume = 1; // 0 to 1
  msg.rate = 0.8; // 0.1 to 10
  msg.pitch = 1.4; // 0 to 2
  msg.text = message;
  msg.lang = 'en-US';
  speechSynthesis.speak(msg);
}